const API_BASE_URL = 'http://185.228.138.13:5000';

export default API_BASE_URL; 